module.exports = __webpack_public_path__ + "img/deco-history.6617430.png";